import React, {Component} from 'react';
import {createFragmentContainer, graphql} from 'react-relay';
import history from '../../../../services/history';
import FloatingActionButton from 'material-ui/FloatingActionButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import ReportHeader from './components/ReportHeader';
import AdminReportGrid from './components/AdminReportGrid';
import UserReportGrid from './components/UserReportGrid';
import CreateWidgetDialog from './components/CreateWidgetDialog';

const styles = {
  wrapper: {
    width: '1200px',
    margin: '0 auto',
  },
  header: {
    margin: '0 0 20px',
  },
  addWidgetButton: {
    position: 'fixed',
    bottom: 30,
    right: 30,
  },
};

class ReportWrapper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      addWidgetDialogOpen: false,
    };
  }

  componentWillMount() {
    if (!this.props.report) {
      history.replace('/');
    }
  }

  showAddWidgetDialog = () => {
    this.setState({addWidgetDialogOpen: true});
  };

  handleAddWidgetDialogClose = () => {
    this.setState({addWidgetDialogOpen: false});
  };

  render() {
    if (!this.props.report) { return null; }
    const isAccountAdmin = this.props.viewer.roles.includes('account_admin');
    return (
      <div style={styles.wrapper}>
        <ReportHeader
          viewer={this.props.viewer}
          report={this.props.report}
          reports={this.props.reports}
          devices={this.props.devices}
          surveys={this.props.surveys}
          style={styles.header}
        />
        {isAccountAdmin ? (
          <AdminReportGrid
            viewer={this.props.viewer}
            report={this.props.report}
            reports={this.props.reports}
            surveys={this.props.surveys}
          />
        ) : (
          <UserReportGrid
            viewer={this.props.viewer}
            report={this.props.report}
            reports={this.props.reports}
            surveys={this.props.surveys}
          />
        )}
        {isAccountAdmin && (
          <div>
            <FloatingActionButton
              onTouchTap={this.showAddWidgetDialog}
              style={styles.addWidgetButton}
            >
              <ContentAdd />
            </FloatingActionButton>
            <CreateWidgetDialog 
              report={this.props.report}
              surveys={this.props.surveys}
              open={this.state.addWidgetDialogOpen} 
              onClose={this.handleAddWidgetDialogClose}
            />
          </div>
        )}
      </div>
    );
  }
}

export default createFragmentContainer(
  ReportWrapper,
  graphql`
    fragment ReportWrapper_viewer on Viewer {
      roles
      ...ReportHeader_viewer
      ...AdminReportGrid_viewer
      ...UserReportGrid_viewer
    }
    fragment ReportWrapper_report on Report {
      ...ReportHeader_report
      ...AdminReportGrid_report
      ...UserReportGrid_report
      ...CreateWidgetDialog_report
    }
    fragment ReportWrapper_devices on DeviceConnection {
      ...ReportHeader_devices
    }
    fragment ReportWrapper_surveys on SurveyConnection {
      ...ReportHeader_surveys
      ...AdminReportGrid_surveys
      ...UserReportGrid_surveys
      ...CreateWidgetDialog_surveys
    }
    fragment ReportWrapper_reports on ReportConnection {
      ...ReportHeader_reports
      ...UserReportGrid_reports
      ...AdminReportGrid_reports
    }
  `,
);



// WEBPACK FOOTER //
// ./src/scenes/Report/components/ReportWrapper/ReportWrapper.js